import {openLandingUrl} from '@zzng/common/utils/openLandingUrl';

import {HomeRes} from '@/root/models/home';

import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';

type Props = {
  notice: HomeRes['notice'];
};

const Notice = ({notice}: Props) => {
  const {trackEvent} = useTiara({pageName: TIARA_PAGE_NAME.HOME});

  const onClickNotice = () => {
    if (!notice) return;
    trackEvent({action: TIARA_ACTION.NOTICE_CLICK});
    openLandingUrl(notice.landingUrl);
  };

  if (!notice) return null;

  return (
    <div className="notice_g">
      <button type="button" className="btn_notice" onClick={onClickNotice}>
        <span className="icon icon_notice_s_type2">공지사항</span>
        <em className="txt_notice">{notice.message}</em>
        <span className="icon icon_more">더보기</span>
      </button>
    </div>
  );
};

export default Notice;
